import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import "./CSS/AdminTheme.css";
import { SearchProvider } from "./SearchContext";
import { FilterProvider } from "./FilterContext";
import { installDeactivatedAccountGuard } from "./utils/deactivatedAccount";
import { PortalAuthProvider } from "./context/PortalAuthContext";
import { PermissionProvider } from "./context/PermissionContext";

installDeactivatedAccountGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // RR v7 BrowserRouter otherwise wraps history updates in startTransition, which can defer
  // route commits and leave the main outlet showing the previous page until a full reload.
  <BrowserRouter unstable_useTransitions={false}>
    <SearchProvider>
      <FilterProvider>
        <PortalAuthProvider>
          <PermissionProvider>
            <App />
          </PermissionProvider>
        </PortalAuthProvider>
      </FilterProvider>
    </SearchProvider>
  </BrowserRouter>
);

// const allowedOrigins = [
//   "https://preview.100billiontech.com",
//   "https://admin.100billiontech.com",
//   "https://frontend.100billiontech.com",
// 	"https://e.100billionoms.com",
// 	"https://a.100billionoms.com",
// 	"http://localhost:3000",
// 	"http://localhost:3001",
// 	"https://nishafruits.com",
// 	"https://onlineindia.tech",
// 	"https://orabike.in",
// 	"https://thehappyplate.shop",
// 	"https://store.100billiontech.com",
// 	"https://business.100billionoms.com",
// ];

// const corsOptions = {
//   origin: function (origin, callback) {
//     if (!origin || allowedOrigins.includes(origin)) {
//       callback(null, true);
//     } else {
//       callback(new Error("Not allowed by CORS"));
//     }
//   }
// };

// app.use(cors(corsOptions));
